<div class="p-1 size-full flex flex-col items-center justify-center gap-5">
  <div class="w-full h-auto p-2">
    <p-message severity="info" icon="pi pi-info-circle" size="small" class="w-full">
      Przeprowadź procedurę wydawania pojazdu w oparciu o poniższe dane. Procedura wymaga podania zarówno daty wydania
      jak i osoby odbierającej pojazd. Pamiętaj, że operacja nie może zostać wycofana!
    </p-message>
  </div>

  <form
    [formGroup]="vehicleReleaseForm"
    (ngSubmit)="onVehicleReleaseSubmit()"
    class="size-full flex flex-col items-center justify-center gap-10">
    <div class="size-full p-2 flex flex-col items-center justify-center gap-2">
      <app-date-input
        formControlName="vehicleReleaseDate"
        [untilNow]="true"
        [showTime]="true"
        class="w-full"
        labelMode="static"
        label="Data wydania pojazdu"></app-date-input>
      <app-text-input
        formControlName="vehicleReleasePerson"
        class="w-full"
        labelMode="static"
        label="Osoba odbierająca pojazd">
      </app-text-input>
    </div>
    <div class="w-full h-auto p-1 inline-flex justify-end gap-2">
      <p-button
        label="Anuluj"
        severity="primary"
        outlined
        rounded
        (onClick)="onVehicleReleaseCancel()">
      </p-button>
      <p-button
        label="Wydaj pojazd"
        severity="primary"
        rounded
        type="submit"
        [disabled]="vehicleReleaseForm.invalid">
      </p-button>
    </div>
  </form>
</div>
